import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Edit extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <path
            d="M12,0h-1.1L1,10l-0.2,0.4L0,15.1L0.9,16l4.8-0.7L6.1,15L16,5.1V4L12,0z M14.4,4.6L14,4.9l-3-3l0.4-0.4L14.4,4.6z M5.7,12
          c-0.3-0.3-0.8-0.6-1.1-0.7c-0.1-0.2-0.3-0.7-0.7-1.1c-0.2-0.2-0.5-0.4-0.7-0.5L10,3l3,3l-6.8,6.8C6.1,12.5,5.9,12.3,5.7,12z
           M3.2,14.1c-0.1-0.3-0.2-0.6-0.5-0.9c-0.3-0.3-0.6-0.4-0.9-0.5l0.3-1.9l0.5-0.5c0.2,0.1,0.5,0.2,0.7,0.5C3.8,11.2,4,11.8,4,11.8
          C4,11.9,4.1,12,4.2,12c0,0,0.6,0.2,0.9,0.6c0.2,0.2,0.4,0.6,0.5,0.7l-0.5,0.5L3.2,14.1z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Edit.js